// services/languageService.js
import axios from 'axios';

// Available language options for transcription
export const languageOptions = [
  { value: "nb-NO", label: "Norsk (Bokmål)", flag: "🇳🇴" },
  { value: "en-US", label: "English (US)", flag: "🇺🇸" },
  { value: "ar-SA", label: "العربية", flag: "🇸🇦" },
  { value: "zh-CN", label: "中文", flag: "🇨🇳" },
  { value: "da-DK", label: "Dansk", flag: "🇩🇰" },
  { value: "nl-NL", label: "Nederlands", flag: "🇳🇱" },
  { value: "fi-FI", label: "Suomi", flag: "🇫🇮" },
  { value: "fr-FR", label: "Français", flag: "🇫🇷" },
  { value: "de-DE", label: "Deutsch", flag: "🇩🇪" },
  { value: "hi-IN", label: "हिंदी", flag: "🇮🇳" },
  { value: "it-IT", label: "Italiano", flag: "🇮🇹" },
  { value: "ja-JP", label: "日本語", flag: "🇯🇵" },
  { value: "pt-PT", label: "Português", flag: "🇵🇹" },
  { value: "es-ES", label: "Español", flag: "🇪🇸" },
  { value: "sv-SE", label: "Svenska", flag: "🇸🇪" }
];

/**
 * Set the transcription language
 * @param {string} apiBaseUrl - The base URL for the API
 * @param {string} language - The language code to set
 * @returns {Promise<Object>} - Response from the server
 */
export const setTranscriptionLanguage = async (apiBaseUrl, language, userId) => {
  try {
    const response = await axios.post(
      `${apiBaseUrl}/set-language`, 
      { language },
      {
        headers: {
          'X-User-Id': userId
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error changing language:', error);
    throw new Error('Kunne ikke endre språk. Prøv igjen senere.');
  }
};

/**
 * Get language option details by language code
 * @param {string} languageCode - The language code to look up
 * @returns {Object|null} - The language option details or null if not found
 */
export const getLanguageDetails = (languageCode) => {
  return languageOptions.find(option => option.value === languageCode) || null;
};

/**
 * Get the display name for a language code
 * @param {string} languageCode - The language code to look up
 * @returns {string} - The display name of the language
 */
export const getLanguageDisplayName = (languageCode) => {
  const language = getLanguageDetails(languageCode);
  return language ? language.label : languageCode;
};

/**
 * Get the flag emoji for a language code
 * @param {string} languageCode - The language code to look up
 * @returns {string} - The flag emoji for the language
 */
export const getLanguageFlag = (languageCode) => {
  const language = getLanguageDetails(languageCode);
  return language ? language.flag : '';
};